/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ total: NonNullable<unknown> }} Notificationcenter_Countshownall3Inputs */

const en_notificationcenter_countshownall3 = /** @type {(inputs: Notificationcenter_Countshownall3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Showing all ${i?.total}`)
};

/**
* | output |
* | --- |
* | "Showing all {total}" |
*
* @param {Notificationcenter_Countshownall3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const notificationcenter_countshownall3 = /** @type {((inputs: Notificationcenter_Countshownall3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notificationcenter_Countshownall3Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_notificationcenter_countshownall3(inputs)
});
export { notificationcenter_countshownall3 as "notificationCenter_countShownAll" }